export default {
      id: "check-circle-bg-usage",
      viewBox: "0 0 22 23",
      url: __webpack_public_path__ + "sprite.svg#check-circle-bg",
      toString: function () {
        return this.url;
      }
    }